import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {ReleaseReportLockInput, ReleaseReportLockMutation} from './__generated__/ReleaseReportLockMutation.graphql';

const mutation = graphql`
	mutation ReleaseReportLockMutation($input: ReleaseReportLockInput!) {
		releaseReportLock(input: $input) {
			released
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<ReleaseReportLockInput>,
	onSuccess?: RelayOnCompleted<ReleaseReportLockMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
